module.exports = __webpack_public_path__ + "img/status_1.16ccde5e.png";